import { Container, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import Page from '../../components/Page';
import ProfileDialogContent from '../../components/common/ProfileDialogContent';
import { captureAGIdentify } from '../../analytics/google.analytics';

export default function StudentProfile() {
  const currentUser = useSelector((state) => state.auth.currentUser);
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [isOtpScreen, setOtpVerifyScreen] = useState(false);

  useEffect(() => {
    captureAGIdentify(currentUser, 'student_profile');
  }, []);

  return (
    <Page title="Account">
      <Container>
        <Typography variant="h4" mb={4}>
          Personal Details
        </Typography>
        <ProfileDialogContent
          setOtpVerifyScreen={setOtpVerifyScreen}
          setFormSubmitting={setFormSubmitting}
          isOtpScreen={isOtpScreen}
          displayButton
          formSubmitting={formSubmitting}
        />
      </Container>
    </Page>
  );
}
